import { FormikErrors } from "formik";
import React, { ReactNode } from "react";

interface ErrorProps {
	ariaLive?: "assertive" | "polite" | "off";
	children?: string | string[] | FormikErrors<any> | FormikErrors<any>[];
}

const Error: React.FC<ErrorProps> = ({ children, ariaLive }) => {
	return (
		<small aria-live={ariaLive} className="error">
			{(children as unknown) as React.ReactElement}
		</small>
	);
};

export default Error;
